import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { PageNotFound } from '@guuru/react-error-pages';
import LoadingView from '@guuru/react-loading';
import BasicLayout from '../../containers/BasicLayout';
import useSetLanguage from './hooks/useSetLanguage';
import useSetPrintListeners from './hooks/useSetPrintListeners';

const QuizDeciderView = lazy(() => import('../Quiz/QuizDeciderView'));
const Pages = lazy(() => import('../Pages'));
const Page = lazy(() => import('../Page'));

const MainView = function () {
  const { loading } = useSetLanguage();
  useSetPrintListeners();

  if (loading) {
    return <LoadingView />;
  }

  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingView />}>
        <main>
          <Routes>
            <Route path="*" element={<PageNotFound />} />
            <Route path="/quizzes" element={<BasicLayout />}>
              <Route index element={<QuizDeciderView />} />
            </Route>
            <Route path="/:partnerId" element={<BasicLayout />}>
              <Route index element={<Pages />} />
              <Route path="articles">
                <Route index element={<Pages />} />
                <Route path=":articleId" element={<Page />} />
              </Route>
            </Route>
          </Routes>
        </main>
      </Suspense>
    </BrowserRouter>
  );
};

export default MainView;
